<nav class="head-nav">
  <div class="nav-container">
    <h2 *ngIf="isProfile">{{"routes.My Profile" | translate}}</h2>
    <h2 *ngIf="!isProfile">{{'users.consumerAmbassadors' | translate}}</h2>
    <div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]='["/main/central-hub"]'>{{ "general.Home" | translate }}</a>
        </li>
        @if (!isProfile) {
        <li class="breadcrumb-item" *ngIf="centralHubName">
          {{ 'general.' + centralHubName | translate}}
        </li>
        <li class="breadcrumb-item">
          <a [routerLink]='[`/admin/${systemModule.UserManagement}/ambassador-users`]'>
            {{ "users.consumerAmbassadors" | translate }}
          </a>
        </li>
        } @else {
        <li class="breadcrumb-item">
          {{ "routes.My Profile" | translate }}
        </li>
        }

      </ol>
    </div>
  </div>
</nav>

<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<div class="pageDetails profileSection" *ngIf="!dataLoading">
  <div class="fade-in first-row">
    <div class="row">
      <div class="col-xl-5 col-lg-7 col-12">
        <div class="pageDetails-part1">
          <div class="entityImg">
            <img *ngIf="userInformation.profilePicture" [src]="userInformation.profilePicture"
              (error)="userInformation.profilePicture = ''" />
            <span class="profile-nickName" *ngIf="!userInformation.profilePicture">{{ userInformation.name | shortName
              }}</span>
          </div>
          <div class="detailsItem">
            <div class="title">
              <span>{{userInformation.name}}</span>
            </div>
            <!-- <div class="title">
              <span>{{userInformation.role}}</span>
            </div> -->
            <p class="mt-3">{{userInformation.identityNumber}}</p>
            <div class="createdTime">
              <span>{{ 'users.joinDate' | translate }}:</span>
              <span class="time"> {{userInformation.joinedDate| date:' dd MMMM, yyyy'}} </span>
            </div>
            <div [ngClass]="{'status-waiting':userInformation.status == userStatusEnum.NOT_VERIFIED || userInformation.status == 0,
                        'status-active':userInformation.status == userStatusEnum.ACTIVE,
                         'status-inactive':userInformation.status == userStatusEnum.INACTIVE}">
              <svg width="12" height="12" viewBox="0 0 12 12">
                <circle id="circle" cx="6" cy="6" r="6" />
              </svg>
              <span class="text-custom">
                <span *ngIf="userInformation.status == userStatusEnum.NOT_VERIFIED || userInformation.status == 0">
                  {{ 'users.notVerified' |
                  translate }} </span>
                <span *ngIf="userInformation.status == userStatusEnum.ACTIVE">{{ 'users.Active Account' | translate
                  }}</span>
                <span *ngIf="userInformation.status == userStatusEnum.INACTIVE"> {{ 'users.Suspended Account' |
                  translate }}
                </span>
              </span>
            </div>
            <!-- <div class="earnedBadges" *ngIf="userInformation.badges && userInformation.badges.length">
              <span>{{ 'badges.earnedBadges' | translate }}:</span>
              <ul>
                <li *ngFor="let item of userInformation.badges">
                  <div class="hexagon-icon" [matTooltip]="item.title">
                    <img
                      [src]="item.iconType == iconTypeEnum.System ? './assets/images/badges/' + item.iconPath : item.iconPath"
                      alt="Badge Icon">
                  </div>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-5 col-12">
        <ul class="pageDetails-part2">
          <!-- <li *ngIf="userInformation.jobTitle" class="job-title">
            <svg width="15.998" height="14" viewBox="0 0 15.998 14">
              <path id="job-title-icon"
                d="M2137.408,16008a1.4,1.4,0,0,1-1.406-1.4v-10.193l1.683,5.037a1.4,1.4,0,0,0,1.334.955h2.635v.464a.469.469,0,0,0,.47.468h3.752a.465.465,0,0,0,.466-.468v-.464h2.64a1.408,1.408,0,0,0,1.334-.955l1.683-5.037v10.193a1.4,1.4,0,0,1-1.406,1.4Zm5.187-5.6v-.936h2.812v.936Zm3.748-.936V16001a.466.466,0,0,0-.466-.468h-3.752a.47.47,0,0,0-.47.468v.464h-2.635a.472.472,0,0,1-.446-.316l-1.768-5.284h3.913v-.464a1.4,1.4,0,0,1,1.406-1.4h3.752a1.4,1.4,0,0,1,1.406,1.4v.464h3.909l-1.768,5.284a.467.467,0,0,1-.442.316Zm-4.688-6.064v.464h4.688v-.464a.466.466,0,0,0-.466-.468h-3.752A.47.47,0,0,0,2141.654,15995.4Z"
                transform="translate(-2136.002 -15994.002)" fill="#b5ccd9" />
            </svg>
            <div class="values">
              <div>{{userInformation.jobTitle}}</div>
            </div>
          </li>-->
          <li class="job-title">
            <svg width="15.998" height="14" viewBox="0 0 15.998 14">
              <path id="job-title-icon"
                d="M2137.408,16008a1.4,1.4,0,0,1-1.406-1.4v-10.193l1.683,5.037a1.4,1.4,0,0,0,1.334.955h2.635v.464a.469.469,0,0,0,.47.468h3.752a.465.465,0,0,0,.466-.468v-.464h2.64a1.408,1.408,0,0,0,1.334-.955l1.683-5.037v10.193a1.4,1.4,0,0,1-1.406,1.4Zm5.187-5.6v-.936h2.812v.936Zm3.748-.936V16001a.466.466,0,0,0-.466-.468h-3.752a.47.47,0,0,0-.47.468v.464h-2.635a.472.472,0,0,1-.446-.316l-1.768-5.284h3.913v-.464a1.4,1.4,0,0,1,1.406-1.4h3.752a1.4,1.4,0,0,1,1.406,1.4v.464h3.909l-1.768,5.284a.467.467,0,0,1-.442.316Zm-4.688-6.064v.464h4.688v-.464a.466.466,0,0,0-.466-.468h-3.752A.47.47,0,0,0,2141.654,15995.4Z"
                transform="translate(-2136.002 -15994.002)" fill="#b5ccd9" />
            </svg>
            <span>
              {{ 'fields.ambassador' |translate }}
            </span>
          </li>
          <li *ngIf="userInformation.cityName && userInformation.countryName" class="location">
            <svg width="16" height="21" viewBox="0 0 16 21">
              <path id="location-icon"
                d="M72,0a7.947,7.947,0,0,0-8,7.875c0,5.81,7.381,12.715,7.7,13.006a.45.45,0,0,0,.609,0c.314-.291,7.7-7.2,7.7-13.006A7.947,7.947,0,0,0,72,0Zm0,12.25a4.415,4.415,0,0,1-4.444-4.375,4.445,4.445,0,0,1,8.889,0A4.415,4.415,0,0,1,72,12.25Z"
                transform="translate(-64)" fill="#b5ccd9" />
            </svg>
            <span>{{userInformation.cityName}},</span>
            <span>{{userInformation.countryName}}</span>
          </li>
          <li *ngIf="userInformation.phoneNumber" class="phone">
            <svg width="16" height="16" viewBox="0 0 16 16">
              <path id="phone-icon"
                d="M2143.693,7457.518l-6.222-6.225a5.062,5.062,0,0,1-.244-6.873l3.969,3.968a1.055,1.055,0,0,0,.072,1.4l3.932,3.934a1.055,1.055,0,0,0,1.4.072l3.969,3.969a5.033,5.033,0,0,1-6.873-.244Zm3.585-4.369.332-.332a1.441,1.441,0,0,1,1.989,0l1.988,1.989a1.405,1.405,0,0,1,0,1.989l-.332.331Zm-9.416-9.418.332-.332a1.441,1.441,0,0,1,1.989,0l1.989,1.989a1.405,1.405,0,0,1,0,1.989l-.331.332Z"
                transform="translate(-2136 -7443)" fill="#b5ccd9" />
            </svg>
            <span>{{userInformation.countryKey}} {{userInformation.phoneNumber}}</span>
          </li>
          <li *ngIf="userInformation.email" class="gmail">
            <svg width="16.001" height="12.797" viewBox="0 0 16.001 12.797">
              <path id="email-icon"
                d="M15287.006,19231.8v-.01c-.05,0-.085.008-.131.01h-1.749a2.7,2.7,0,0,1-.792-.232,1.771,1.771,0,0,1-.861-.914,4.159,4.159,0,0,1-.274-1.66,2.989,2.989,0,0,1,.68-2.133,3.3,3.3,0,0,1,3.951-.121,2.6,2.6,0,0,1,.6,1.906v.084a5.849,5.849,0,0,1-.065,1.008.858.858,0,0,1-.192.463.451.451,0,0,1-.328.121.445.445,0,0,1-.328-.1.724.724,0,0,1-.124-.428c-.02-.221-.027-.605-.027-1.154v-1.422h-.842v.109a2.418,2.418,0,0,0-.394-.137,1.563,1.563,0,0,0-.386-.057,1.337,1.337,0,0,0-1.175.479,2.556,2.556,0,0,0-.34,1.477,2.369,2.369,0,0,0,.367,1.5,1.283,1.283,0,0,0,1.038.434,1.7,1.7,0,0,0,.634-.137,2.817,2.817,0,0,0,.595-.3.716.716,0,0,0,.332.309,1.335,1.335,0,0,0,.649.141,1.217,1.217,0,0,0,1.073-.52,1.117,1.117,0,0,0,.069-.137,1.513,1.513,0,0,1-.437.938,1.692,1.692,0,0,1-1.128.486Zm-12.43,0a1.682,1.682,0,0,1-1.123-.486,1.514,1.514,0,0,1-.453-1.121v-9.584a1.506,1.506,0,0,1,.453-1.119,1.664,1.664,0,0,1,1.123-.486h12.843a1.661,1.661,0,0,1,1.128.49,1.516,1.516,0,0,1,.452,1.121v6.479a2.555,2.555,0,0,0-.561-.877,3.489,3.489,0,0,0-2.537-.812,3.625,3.625,0,0,0-2.613.887,3.569,3.569,0,0,0-.931,2.7,4.748,4.748,0,0,0,.4,2.152,2.439,2.439,0,0,0,.475.654Zm0-9.58,6.418,3.969,6.421-3.969v-1.605l-6.421,4-6.418-4Zm10.665,7.789a1.9,1.9,0,0,1-.162-.914,3.054,3.054,0,0,1,.065-.7.64.64,0,0,1,.244-.389.843.843,0,0,1,.517-.133,2.448,2.448,0,0,1,.61.109v1a7.846,7.846,0,0,0,.055,1.035,3.341,3.341,0,0,1-.444.18,1.369,1.369,0,0,1-.429.082A.509.509,0,0,1,15285.245,19230.008Z"
                transform="translate(-15272.999 -19219.002)" fill="#b5ccd9" />
            </svg>

            <a class="email" href="mailto:{{userInformation.email}}"
              [matTooltip]="userInformation.email">{{userInformation.email}}</a>
          </li>

        </ul>
      </div>
      <div class="col-xl-3 col-lg-12 col-md-12 col-12">
        <div class="btn-container d-flex align-items-center">
          <button mat-button class="btn-grey" (click)="openUpdateForm()" *ngIf="userInformation.canEdit">
            <svg width="16" height="16.004" viewBox="0 0 16 16.004">
              <path id="edit-icon"
                d="M5.82,14l-3.63-3.63,8.78-8.78,3.63,3.63ZM1.851,11.011l3.33,3.33L.188,16Zm13.865-6.9-.63.63L11.451,1.1l.63-.63a1.624,1.624,0,0,1,2.3,0l1.338,1.338a1.633,1.633,0,0,1,0,2.3Zm0,0"
                transform="translate(-0.188 0.001)" fill="#888" />
            </svg>
            <span>{{ 'general.Edit' | translate }}</span>
          </button>
          <button *ngIf="userInformation.canDelete" mat-icon-button class="btn-grey mx-3"
            [matTooltip]="'general.Delete' | translate" (click)="deleteUser(userInformation.id)">
            <mat-icon>delete</mat-icon>
          </button>

          <button type="button" mat-icon-button [matTooltip]="'users.Resend Verification Mail' | translate"
            *ngIf="(userInformation.userstatus == userTabsEnum.NOT_VERIFIED) && userInformation.canSendVerification"
            (click)="resendVerificationMail(userInformation.id)">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path id="email-refresh"
                d="M18,.929v1.99a.831.831,0,0,1-.831.831h-1.99a.552.552,0,0,1-.391-.943l.719-.719A2.585,2.585,0,0,0,13.859,1.5a2.609,2.609,0,1,0,2.156,4.078.75.75,0,0,1,1.24.846A4.109,4.109,0,1,1,13.859,0a4.068,4.068,0,0,1,2.71,1.025l.488-.487A.552.552,0,0,1,18,.929ZM9,11.566a2.246,2.246,0,0,0,1.591-.657l1.466-1.466A5.6,5.6,0,0,1,8.577,2.25H3.75A3.74,3.74,0,0,0,.558,4.058L7.409,10.91A2.245,2.245,0,0,0,9,11.566ZM13.875,9.75h0l-2.22,2.22a3.755,3.755,0,0,1-5.3,0L.034,5.656C.024,5.771,0,5.882,0,6v8.25A3.754,3.754,0,0,0,3.75,18h10.5A3.754,3.754,0,0,0,18,14.25l-.01-6.3A5.6,5.6,0,0,1,13.875,9.75Z"
                fill="#6b6d85" />
            </svg>
          </button>
          <!-- <button *ngIf="(userInformation.userstatus == userTabsEnum.NOT_VERIFIED) && userInformation.canSendVerification"
            class="btn-grey" mat-button (click)="resendVerificationMail(userInformation.id)">
            <svg width="20" height="12" viewBox="0 0 20 12">
              <path id="activate-icon"
                d="M934.87,458h-8a6,6,0,0,0,0,12h8a6,6,0,0,0,0-12Zm-8,10.333A4.333,4.333,0,1,1,931.2,464,4.333,4.333,0,0,1,926.87,468.333Zm11.4-5.9-3.583,3.821-.028.029a.44.44,0,0,1-.621-.029l-1.5-1.6a.514.514,0,0,1,0-.693l.014-.013a.449.449,0,0,1,.635.013l1.175,1.254,3.258-3.476.027-.027a.441.441,0,0,1,.622.027v0A.513.513,0,0,1,938.266,462.436Z"
                transform="translate(-920.87 -458)" fill="#00aa1d" />
            </svg>
            <span>{{ 'general.Activate' | translate }}</span>
          </button> -->
          <button *ngIf="(userInformation.userstatus == userTabsEnum.SUSPENDED) && userInformation.canUnSuspend"
            class="btn-grey" mat-button (click)="suspendUnSuspendUser(userInformation.id ,'ACTIVE')">
            <svg width="20" height="12" viewBox="0 0 20 12">
              <path id="activate-icon"
                d="M934.87,458h-8a6,6,0,0,0,0,12h8a6,6,0,0,0,0-12Zm-8,10.333A4.333,4.333,0,1,1,931.2,464,4.333,4.333,0,0,1,926.87,468.333Zm11.4-5.9-3.583,3.821-.028.029a.44.44,0,0,1-.621-.029l-1.5-1.6a.514.514,0,0,1,0-.693l.014-.013a.449.449,0,0,1,.635.013l1.175,1.254,3.258-3.476.027-.027a.441.441,0,0,1,.622.027v0A.513.513,0,0,1,938.266,462.436Z"
                transform="translate(-920.87 -458)" fill="#00aa1d" />
            </svg>
            <span>{{ 'entities.unsuspend' | translate }}</span>
          </button>

          <button *ngIf="userInformation.userstatus == userTabsEnum.ACTIVE && userInformation.canSuspend"
            class="btn-grey" mat-button (click)="suspendUnSuspendUser(userInformation.id ,'SUSPENDED' )">
            <svg width="20" height="12" viewBox="0 0 20 12">
              <path id="deactivate-icon"
                d="M910.643,466.955h-8a6,6,0,0,0,0,12h8a6,6,0,0,0,0-12Zm-8.093,8.25a.75.75,0,0,1-1.5,0v-4.5a.75.75,0,0,1,1.5,0Zm8.093,2.083a4.333,4.333,0,1,1,4.332-4.333A4.332,4.332,0,0,1,910.643,477.288Z"
                transform="translate(-896.643 -466.955)" fill="#AF0D0D" />
            </svg>
            <span>{{ 'general.Deactivate' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-7 col-lg-7 col-12 mb-2" *ngIf="userInformation.subscriptionData">
      <div class="fade-in first-row mt-0">
        <div class="row-header">
          <h3>{{"membership.subscriptionData" | translate}}</h3>
        </div>
        <div class="subscription-data">
          <div class="data-item">
            <span>{{ 'membership.currentPlan' | translate }}:</span>
            <div class="current-plan">
              <div class="plan-type"
                *ngIf="userInformation.subscriptionData.planTiltleName == subscriptionTypeEnum.ActiveMember">
                {{ 'membership.activeMember' | translate }}
              </div>
              <div class="plan-type"
                *ngIf="userInformation.subscriptionData.planTiltleName == subscriptionTypeEnum.AffiliateMember">
                {{ 'membership.affiliateMember' | translate }}
              </div>
              <span class="plan-number">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
                  <path id="symbol_saudi_arabia_riyal_sar"
                    d="M9.958,15.946,16,14.653a6.631,6.631,0,0,1-.547,2.054L9.411,18A6.628,6.628,0,0,1,9.958,15.946ZM.547,14.589l5.1-1.091V11.059L.888,12.076a6.631,6.631,0,0,1,.547-2.054l4.212-.9V1.59A6.649,6.649,0,0,1,7.529,0V8.719l1.882-.4V2.538A6.652,6.652,0,0,1,11.293.947V7.913L16,6.907a6.627,6.627,0,0,1-.547,2.054l-4.16.89v1.937L16,10.78a6.627,6.627,0,0,1-.547,2.054h0L9.411,14.127V10.253l-1.882.4V12.8a.946.946,0,0,1-.161.53h0L6.389,14.8a1.7,1.7,0,0,1-1.051.705L0,16.643A6.627,6.627,0,0,1,.547,14.589Z"
                    fill="#469595" />
                </svg>
                <span class="amount">{{ userInformation.subscriptionData.amount }}</span> / {{"register.yearly" |
                translate}}
              </span>
            </div>
          </div>
          <div class="data-item">
            <div class="item">
              <label>{{ 'membership.startedOn' | translate }}:</label>
              <span>{{userInformation.subscriptionData.startedOn | date:'MMMM dd , yyyy'}}</span>
            </div>
            <div class="item">
              <label>{{ 'membership.validTill' | translate }}:</label>
              <span>{{userInformation.subscriptionData.validTo | date:'MMMM dd , yyyy'}}</span>
            </div>
            <div class="item text-end">
              <span class="badge-status active"
                *ngIf="userInformation.subscriptionData.status == subscribtionStatusEnum.Active">
                {{ 'users.Active' | translate }}
              </span>
              <span class="badge-status warning"
                *ngIf="userInformation.subscriptionData.status == subscribtionStatusEnum.Deactivated">
                {{ 'users.Inactive' | translate }}
              </span>
              <span class="badge-status danger"
                *ngIf="userInformation.subscriptionData.status == subscribtionStatusEnum.ExpiredSoon">
                {{ 'payment.expiringSoon' | translate }}
              </span>
              <span class="badge-status danger"
                *ngIf="userInformation.subscriptionData.status == subscribtionStatusEnum.Expired">
                {{ 'payment.Expired' | translate }}
              </span>
            </div>
          </div>
        </div>
        <div class="subscription-actions">
          <button class="btn w-auto m-0 customBtn" [class.loading]="reNewSubscriptionLoading"
            [disabled]="reNewSubscriptionLoading" (click)="renewSubscription()"
            *ngIf="userInformation.subscriptionData.canRenewSubscription">
            {{ 'payment.Renew' | translate }}
          </button>
          <button class="btn btn-outline-light" (click)="viewHistory()"
            *ngIf="userInformation.subscriptionData.canViewSubscriptionHistory">
            {{ 'membership.viewHistory' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-xl-7 col-lg-7 col-12 mb-2" *ngIf="userInformation.ambassadorLevel">
      <div class="fade-in first-row mt-0">
        <div class="row-header">
          <h3>{{"ambassadors.ambassadorLevel" | translate}}</h3>
        </div>
        <div class="subscription-data ambassador-level">
          <div>
            <div class="data-item">
              <span>{{ 'ambassadors.currentLevel' | translate }}:</span>
              <div class="current-plan">
                <div class="plan-type"
                  *ngIf="userInformation.ambassadorLevel.currentLevel == ambassadorPromotionLevelEnum.ConsumerAmbassador">
                  {{ 'ambassadors.consumerAmbassador' | translate }}
                </div>
                <div class="plan-type"
                  *ngIf="userInformation.ambassadorLevel.currentLevel == ambassadorPromotionLevelEnum.LeadAmbassador">
                  {{ 'ambassadors.leadAmbassador' | translate }}
                </div>
                <div class="plan-type"
                  *ngIf="userInformation.ambassadorLevel.currentLevel == ambassadorPromotionLevelEnum.ProfessionalAmbassador">
                  {{ 'ambassadors.professionalAmbassador' | translate }}
                </div>
              </div>
            </div>
            @if (userInformation.ambassadorLevel.nextLevel && userInformation.ambassadorLevel.nextLevel !=
            userInformation.ambassadorLevel.currentLevel) {
            <div class="data-item">
              <div class="item">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                  <path id="Path_104510" data-name="Path 104510"
                    d="M10,0A10,10,0,1,1,2.929,2.929,10,10,0,0,1,10,0Zm3.66,15.4V12.888l-3.687-2.7-3.687,2.7V15.4l3.687-2.7Zm1-4.277V7.944L10,4.53,5.336,7.944V11.12L10,7.707Z"
                    fill="#225c80" fill-rule="evenodd" />
                </svg>
                <label> {{ 'ambassadors.nextLevel' | translate }}: </label>
                <span
                  *ngIf="userInformation.ambassadorLevel.nextLevel == ambassadorPromotionLevelEnum.ConsumerAmbassador">
                  {{ 'ambassadors.consumerAmbassador' | translate }}
                </span>
                <span *ngIf="userInformation.ambassadorLevel.nextLevel == ambassadorPromotionLevelEnum.LeadAmbassador">
                  {{ 'ambassadors.leadAmbassador' | translate }}
                </span>
                <span
                  *ngIf="userInformation.ambassadorLevel.nextLevel == ambassadorPromotionLevelEnum.ProfessionalAmbassador">
                  {{ 'ambassadors.professionalAmbassador' | translate }}
                </span>
              </div>
            </div>
            }
          </div>
          <div class="data-item" *ngIf="userInformation.ambassadorLevel.promotedOn">
            <div class="item">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path id="time-icon"
                  d="M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0Zm3.8,12.138a.666.666,0,0,1-.943,0L7.529,8.8a.664.664,0,0,1-.2-.471V4A.667.667,0,1,1,8.667,4V8.057L11.8,11.2a.666.666,0,0,1,0,.943Zm0,0"
                  fill="#bdced9" />
              </svg>
              <label> {{ 'ambassadors.promotedOn' | translate }}: </label>
              <span> {{userInformation.ambassadorLevel.promotedOn | date:'MMMM dd , yyyy'}}</span>
            </div>
          </div>
        </div>
        <div class="ambassador-data">
          <div class="data-item">
            <div class="item">
              <span> {{ 'ambassadors.volunteerHours' | translate }}: </span>
              <strong> {{ userInformation.ambassadorLevel.volunteerHours }} {{ 'tasks.hrs' | translate }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-5 col-lg-5 col-12 mb-2" *ngIf="userInformation.canViewMembershipNumberData">
      <div class="fade-in first-row mt-0">
        <div class="row-header">
          <h3>{{"users.membershipCard" | translate}}</h3>
          <button class="btn btn-outline-light" (click)="print()" [ngClass]="{ 'loading': loading}" *ngIf='!dataLoading'
            [disabled]="loading">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path id="print-icon"
                d="M8165.349,13179a1.963,1.963,0,0,1-1.962-1.959v-2.346h-.287a3.106,3.106,0,0,1-3.1-3.1v-4.575a3.1,3.1,0,0,1,3.1-3.1h.287v-1.812a3.107,3.107,0,0,1,3.108-3.1h7.012a3.1,3.1,0,0,1,3.1,3.1v1.813h.291a3.1,3.1,0,0,1,3.1,3.1v4.575a3.107,3.107,0,0,1-3.1,3.1h-.291v2.346a1.96,1.96,0,0,1-1.959,1.959Zm-.326-1.959a.327.327,0,0,0,.326.329h9.3a.33.33,0,0,0,.329-.329v-5.4h-9.954Zm11.584-3.981h.291a1.473,1.473,0,0,0,1.472-1.469v-4.575a1.476,1.476,0,0,0-1.472-1.473h-13.8a1.473,1.473,0,0,0-1.468,1.473v4.575a1.47,1.47,0,0,0,1.468,1.469h.287v-1.417h-.1a.815.815,0,1,1,0-1.63H8176.7a.815.815,0,1,1,0,1.63h-.1Zm-11.584-10.958v1.813h9.954v-1.812a1.472,1.472,0,0,0-1.471-1.47h-7.012A1.47,1.47,0,0,0,8165.023,13162.1Zm3.449,14.42a.814.814,0,0,1,0-1.629h3.049a.814.814,0,1,1,0,1.629Zm0-2.439a.815.815,0,0,1,0-1.63h3.049a.815.815,0,1,1,0,1.63Zm-5.183-6.1a.814.814,0,1,1,0-1.629h1.83a.814.814,0,1,1,0,1.629Z"
                transform="translate(-8159.999 -13158.999)" fill="#4e7d99" />
            </svg>
            {{ 'meetings.Print' | translate }}
          </button>
        </div>
        <div *ngIf='dataLoading' class="dataLoading">
          <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>
        <ng-container *ngIf='!dataLoading'>
          <div id="cardElement" #cardElement>
            <div class="membership-card">
              <div class="right-side">
                <img class="logo-placeholder" src="./assets/images/logo-section.svg" />
              </div>
              <div class="left-side">
                <div class="user-info-header">
                  <svg xmlns="http://www.w3.org/2000/svg" width="3" height="44" viewBox="0 0 3 44">
                    <g id="Line" transform="translate(-1106.035 -237)">
                      <rect id="line-dark-mint" width="3" height="43.564" rx="1.5"
                        transform="translate(1106.035 237.436)" fill="#4ea5a5" />
                      <rect id="line-mint" width="3" height="33.603" rx="1.5" transform="translate(1106.035 237)"
                        fill="#6be2b7" />
                    </g>
                  </svg>
                  <div class="user-info-content">
                    <div class="user-name">{{membershipInfo.fullName}}</div>
                    <div class="user-role">
                      <ng-container
                        *ngIf="membershipInfo.ambassadorLevel == ambassadorPromotionLevelEnum.ConsumerAmbassador">
                        سفير المستهلك
                      </ng-container>
                      <ng-container
                        *ngIf="membershipInfo.ambassadorLevel == ambassadorPromotionLevelEnum.ProfessionalAmbassador">
                        سفير محترف
                      </ng-container>
                      <ng-container
                        *ngIf="membershipInfo.ambassadorLevel == ambassadorPromotionLevelEnum.LeadAmbassador">
                        سفير قائد الرؤساء
                      </ng-container>
                    </div>
                  </div>
                </div>

                <div class="details-list">
                  <div class="details-item">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12.002" height="9" viewBox="0 0 12.002 9">
                        <path id="membership-number"
                          d="M5138.5,20632a2.5,2.5,0,0,1-2.5-2.5v-4a2.5,2.5,0,0,1,2.5-2.5h7a2.5,2.5,0,0,1,2.5,2.5v4a2.5,2.5,0,0,1-2.5,2.5Zm-1.5-6.5v4a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5v-4a1.5,1.5,0,0,0-1.5-1.5h-7A1.5,1.5,0,0,0,5137,20625.5Zm3.563,4.645a.463.463,0,0,1-.394-.523l.1-.725h-.942l-.119.854a.461.461,0,0,1-.456.4c-.026,0-.046,0-.067,0a.465.465,0,0,1-.394-.523l.1-.725h-.585a.461.461,0,0,1,0-.922h.715l.14-.953h-.642a.461.461,0,1,1,0-.922h.771l.124-.854a.464.464,0,0,1,.456-.395.264.264,0,0,1,.067.006.459.459,0,0,1,.393.523l-.1.719h.938l.124-.854a.464.464,0,0,1,.456-.395.241.241,0,0,1,.067.006.459.459,0,0,1,.394.523l-.1.719h.58a.461.461,0,1,1,0,.922h-.715l-.134.953h.642a.461.461,0,1,1,0,.922h-.771l-.125.854a.461.461,0,0,1-.456.4C5140.6,20630.15,5140.582,20630.146,5140.561,20630.146Zm-1.1-2.17h.942l.135-.953h-.942Zm4.039,2.025a.5.5,0,1,1,0-1h1a.5.5,0,0,1,0,1Zm0-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm0-2a.5.5,0,1,1,0-1h2a.5.5,0,0,1,0,1Z"
                          transform="translate(-5135.999 -20623)" fill="#bdced9" />
                      </svg>
                    </span>
                    <span class="label">رقم العضوية:</span>
                    <span class="value">{{membershipInfo.membershipNumber}}</span>
                  </div>
                  <div class="details-item">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
                        <path id="id-card"
                          d="M2.5,5.75A1.25,1.25,0,1,1,3.75,7,1.25,1.25,0,0,1,2.5,5.75ZM12,9.5v-5A2.5,2.5,0,0,0,9.5,2h-7A2.5,2.5,0,0,0,0,4.5v5A2.5,2.5,0,0,0,2.5,12h7A2.5,2.5,0,0,0,12,9.5ZM9.5,3A1.5,1.5,0,0,1,11,4.5v5A1.5,1.5,0,0,1,9.5,11h-7A1.5,1.5,0,0,1,1,9.5v-5A1.5,1.5,0,0,1,2.5,3ZM10,5a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H9.5A.5.5,0,0,0,10,5Zm0,2a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H9.5A.5.5,0,0,0,10,7ZM9,9a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H8.5A.5.5,0,0,0,9,9Zm-3.9.49A.5.5,0,0,0,5.49,8.9a1.781,1.781,0,0,0-3.479,0,.5.5,0,1,0,.979.2.782.782,0,0,1,1.521,0A.5.5,0,0,0,5.1,9.49Z"
                          transform="translate(0 -2)" fill="#bdced9" />
                      </svg>
                    </span>
                    <span class="label">رقم الهوية:</span>
                    <span class="value">{{membershipInfo.identityNumber}}</span>
                  </div>
                  <div class="details-item">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <path id="calendar-day"
                          d="M4,6H3A1,1,0,0,0,2,7V8A1,1,0,0,0,3,9H4A1,1,0,0,0,5,8V7A1,1,0,0,0,4,6ZM9.5,1H9V.5a.5.5,0,0,0-1,0V1H4V.5a.5.5,0,0,0-1,0V1H2.5A2.5,2.5,0,0,0,0,3.5v6A2.5,2.5,0,0,0,2.5,12h7A2.5,2.5,0,0,0,12,9.5v-6A2.5,2.5,0,0,0,9.5,1Zm-7,1h7A1.5,1.5,0,0,1,11,3.5V4H1V3.5A1.5,1.5,0,0,1,2.5,2Zm7,9h-7A1.5,1.5,0,0,1,1,9.5V5H11V9.5A1.5,1.5,0,0,1,9.5,11Z"
                          fill="#bdced9" />
                      </svg>
                    </span>
                    <span class="label">تاريخ الانضمام:</span>
                    <span class="value">{{membershipInfo.joinedDate | date:'dd/MM/yyyy' }}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="userId">
    <div class="col-12">
      <div class="custom-tab-group">
        <mat-tab-group animationDuration="0ms">
          <mat-tab [label]="'profile.educationalQualifications' | translate">
            <ng-template matTabContent>
              <app-educational-qualifications [userId]="userId"
                [canModify]="userInformation.canModifyProfileEduAndWrokExericeData"></app-educational-qualifications>
            </ng-template>
          </mat-tab>
          <mat-tab [label]="'profile.workExperiences' | translate">
            <ng-template matTabContent>
              <app-work-experiences [userId]="userId"
                [canModify]="userInformation.canModifyProfileEduAndWrokExericeData"></app-work-experiences>
            </ng-template>
          </mat-tab>
          <mat-tab [label]="'profile.volunteeringExperiences' | translate">
            <ng-template matTabContent>
              <app-volunteering-experiences [userId]="userId"
                [canModify]="userInformation.canModifyProfileEduAndWrokExericeData"></app-volunteering-experiences>
            </ng-template>
          </mat-tab>
          <mat-tab [label]="'profile.cvResume' | translate">
            <ng-template matTabContent>
              <app-cv-resume [userId]="userId"
                [canModify]="userInformation.canModifyProfileEduAndWrokExericeData"></app-cv-resume>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
